/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Modal,
  IconButton,
  Alert,
  AlertTitle,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { formatQueryError } from 'renderer/shared/formatters/formatters';
import NotificationForm from './NotificationForm';
import {
  useDeleteNotificationMutation,
  useListNotificationsQuery,
} from '../services/notifications.endpoints';
import { NotificationType } from '../schemas/notifications.schemas';

const Notifications = () => {
  const {
    data: notifications,
    isLoading: listLoading,
    error: listError,
  } = useListNotificationsQuery();
  const [deleteNotification, { error: deleteError }] =
    useDeleteNotificationMutation();
  const [showNotificationForm, setShowNotificationForm] = useState(false);
  const [editingNotification, setEditingNotification] =
    useState<NotificationType | null>(null);

  const handleEditNotification = (notification: any) => {
    setEditingNotification(notification);
    setShowNotificationForm(true);
  };

  const handleCloseForm = () => {
    setShowNotificationForm(false);
    setEditingNotification(null);
  };

  const parseContent = (content: string) => {
    const parts = content.split(/(<b>.*?<\/b>|https?:\/\/[^\s]+)/g);
    return parts.map((part, index) => {
      if (part.startsWith('<b>') && part.endsWith('</b>')) {
        return <b key={index}>{part.replace(/<\/?b>/g, '')}</b>;
      }
      if (/https?:\/\/[^\s]+/.test(part)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ pb: 20 }}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={() => {
                setShowNotificationForm(true);
                setEditingNotification(null);
                // setPreviewNotification(null);
              }}
            >
              Create Notification
            </Button>
          </Grid>
          {listError && (
            <Alert severity="error">{formatQueryError(listError)}</Alert>
          )}
          {deleteError && (
            <Alert severity="error">{formatQueryError(deleteError)}</Alert>
          )}
          {listLoading && (
            <Grid item xs={12}>
              <Alert severity="info">Loading...</Alert>
            </Grid>
          )}
          {notifications &&
            notifications.map((notification, index) => (
              <Grid item xs={12} key={index}>
                <Alert
                  severity={notification.severity}
                  {...(!notification.showIcon && { icon: false })}
                  sx={{
                    mb: 2,
                    border: `1px solid ${
                      notification.severity === 'info'
                        ? '#1976d2'
                        : notification.severity === 'warning'
                        ? '#ff9800'
                        : notification.severity === 'error'
                        ? '#d32f2f'
                        : '#2e7d32'
                    }`,
                    borderRadius: '5px',
                  }}
                  action={
                    <>
                      <IconButton
                        size="small"
                        aria-label="edit"
                        color="inherit"
                        onClick={() => handleEditNotification(notification)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={() => deleteNotification(notification._id)}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </>
                  }
                >
                  <AlertTitle>{notification.title}</AlertTitle>
                  {parseContent(notification.message)}
                </Alert>
              </Grid>
            ))}
        </Grid>
      </Container>
      <Modal
        open={showNotificationForm}
        onClose={handleCloseForm}
        aria-labelledby="create-notification-modal"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: 800,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            outline: 'none',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
            <Typography variant="h6" component="h2">
              {editingNotification
                ? 'Edit Notification'
                : 'Create Notification'}
            </Typography>
            <IconButton onClick={handleCloseForm}>
              <CloseIcon />
            </IconButton>
          </Box>
          <NotificationForm
            mode={editingNotification ? 'edit' : 'create'}
            notification={editingNotification}
          />
        </Box>
      </Modal>
    </>
  );
};

export default Notifications;
